import './foo.css';
const Footer = () => {
    return (
        <div>
            <div className='contact-footer'>
                <div className='contact-social'>
                    <a target='blank' href="https://www.facebook.com/springfest.iitkgp"><i class="fa-brands fa-square-facebook"></i></a>
                    <a target='blank' href="https://www.instagram.com/iitkgp.springfest/?hl=en"><i class="fa-brands fa-square-instagram"></i></a>
                    <a target='blank' href="https://www.linkedin.com/in/sfiitkgp/"><i class="fa-brands fa-linkedin"></i></a>
                    <a target='blank' href="https://twitter.com/springfest_kgp?lang=en"><i class="fa-brands fa-square-twitter"></i></a>
                    <a target='blank' href="https://www.youtube.com/c/SpringFestForever"><i class="fa-brands fa-square-youtube"></i></a>
                </div>
            </div>
        </div>
    );
}

export default Footer;